import { CardQuality } from '#src/__generated__/globalTypes.ts';
import { qualityNames } from '#src/lib/players.ts';
import type { unitMapping } from '#src/lib/style.ts';

import { Stars } from './Stars/index.tsx';

export { Stars } from './Stars/index.tsx';

const convertTierToNumberOfStars = (quality: CardQuality) => {
  return {
    [CardQuality.TIER_0]: 5,
    [CardQuality.TIER_1]: 5,
    [CardQuality.TIER_2]: 4,
    [CardQuality.TIER_3]: 3,
    [CardQuality.TIER_4]: 2,
    [CardQuality.TIER_5]: 1,
  }[quality];
};

type CardQualityStarsProps = {
  cardQuality: CardQuality;
  size?: keyof typeof unitMapping;
};

export const CardQualityStars = ({
  cardQuality,
  size = 1,
}: CardQualityStarsProps) => {
  const nbStars = convertTierToNumberOfStars(cardQuality);
  const sparkles = CardQuality.TIER_0 === cardQuality;
  const accessibilitylabel = qualityNames[cardQuality];

  return (
    <Stars count={nbStars} size={size} sparkles={sparkles}>
      <span className="sr-only">{accessibilitylabel}</span>
    </Stars>
  );
};
